import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {Link} from "react-router-dom";
import {
    useAddSubscriptionMutation,
    useSearchUserByEmailQuery,
    useUpdateMetaMutation,
    useUpdateUserMutation
} from "../../../../types.d";
import {useEffect, useState} from "react";
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import moment from "moment";

interface UserManagementProps extends RouteComponentProps {
}

const CourseCheckbox = (props: {
    title: string;
    disabled?: boolean;
    callback: (value: boolean) => void;
    checked: boolean
}) => {
    return (
        <div className={'form-group'}>
            <label>
                <input
                    type={'checkbox'}
                    disabled={props.disabled}
                    onChange={e => {
                        props.callback(e.currentTarget.checked);
                    }}
                    checked={props.checked}
                />&nbsp;&nbsp;
                { props.title }
            </label>
        </div>
    )
}

const EditableField = (props: {
    userId: number,
    updateKey: string,
    title: string,
    value: string
}) => {
    const [updatedValue, setUpdatedValue] = useState(props.value)
    const [value, setValue] = useState(props.value)
    const [edit, setEdit] = useState(false)

    const [ update, { data } ] = useUpdateUserMutation()

    return (
        <div className={'row pt-2 pb-2'}>
            <div className={'col-2'}>{ props.title }</div>
            <div className={'col-3'}>
                { edit && (
                    <div>
                        <input
                            type={'text'}
                            className={'form-control'}
                            onChange={e => setValue(e.currentTarget.value)}
                            value={value} />

                        <button
                            onClick={e => {
                                setUpdatedValue(value)
                                setEdit(false)

                                update({
                                    variables: {
                                        userId: props.userId,
                                        [props.updateKey]: value
                                    }
                                })
                            }}
                            className={'btn btn-primary mt-2'}>Save</button>
                    </div>
                ) }
                { !edit && updatedValue }
            </div>
            <div className={'col-7'}>
                <a href={''} onClick={async e => {
                    e.preventDefault()

                    if (edit) {
                        setValue(updatedValue)
                    }

                    setEdit(!edit)
                }}>({ edit ? 'Cancel' : 'Edit' })</a>
            </div>
        </div>
    )
}

export const UserManagement = (props: UserManagementProps) => {
    const [modalVisible, setModalVisible] = useState(false)
    const [email, setEmail] = useState('')
    const [confirmedManually, setConfirmedManually] = useState(false)
    const [localCourses, setLocalCourses] = useState([])

    const user = useSearchUserByEmailQuery({
        skip: !email.length,
        variables: { email }
    })

    const userData = user?.data?.user

    const [ activateEmail, { data: activatedEmail } ] = useUpdateMetaMutation({
        variables: { userId: userData?.id, key: 'ig_email_confirmed', value: '1' }
    })

    const [ addSubscription, { data: addedSubscription } ] = useAddSubscriptionMutation()

    useEffect(() => {
        if (userData) {
            setLocalCourses(userData.allCoursesEnabled ? ['all'] : userData.coursesEnabled);
        }
    }, [userData])

    const filteredCourses = userData?.courses?.filter(
        course => course.isAvailable || localCourses.includes('all') || localCourses.includes(course.id)
    ) || []

    console.log(user)

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        User Management
                    </li>
                </ol>
            </nav>

            <div className={'pt-3'}>
                <input
                    type={'text'}
                    placeholder={'Enter email...'}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            setEmail(e.currentTarget.value)
                        }
                    }}
                    className={'form-control'} />
            </div>

            { ((email.length > 0 && !user.loading && !user.data) || user.error) && (
                <div className={'alert alert-warning mt-4'}>User not found</div>
            ) }

            { user.data && !user.loading && !user.error && (
                <>
                    <div className={'mt-4'} />

                    {/*<div className={'row pt-2 pb-2'}>
                        <div className={'col-2'}>Email</div>
                        <div className={'col-10'}>{ userData.email }</div>
                    </div>

                    <div className={'row pt-2 pb-2'}>
                        <div className={'col-2'}>Name</div>
                        <div className={'col-10'}>{ userData.firstName }</div>
                    </div>

                    <div className={'row pt-2 pb-2'}>
                        <div className={'col-2'}>Family name</div>
                        <div className={'col-10'}>{ userData.lastName }</div>
                    </div>*/}

                    <EditableField
                        key={`email_${userData.id}`}
                        userId={userData.id}
                        updateKey={'email'}
                        title={'Email'}
                        value={userData.email} />

                    <EditableField
                        key={`fn_${userData.id}`}
                        userId={userData.id}
                        updateKey={'firstName'}
                        title={'Name'}
                        value={userData.firstName} />

                    <EditableField
                        key={`ln_${userData.id}`}
                        userId={userData.id}
                        updateKey={'lastName'}
                        title={'Family name'}
                        value={userData.lastName} />

                    <div className={'row pt-2 pb-2'}>
                        <div className={'col-2'}>Registered</div>
                        <div className={'col-3'}>{ (!userData.emailConfirmed && !confirmedManually) ? 'Not confirmed' : (
                            userData.registered + ` (${moment().diff(moment(userData.registered), 'days')} days)`
                        ) }</div>
                        <div className={'col-7'}>
                            { !userData.emailConfirmed && !confirmedManually && <a href={''} onClick={async e => {
                                e.preventDefault();
                                await activateEmail();
                                setConfirmedManually(true);
                            }}>(Confirm manually)</a> }

                            { confirmedManually && '(Confirmed)' }
                        </div>
                    </div>

                    <div className={'row pt-2 pb-2'}>
                        <div className={'col-2'}>Status</div>
                        <div className={'col-3'}>
                            { filteredCourses.map(course => {
                                return <div className={'pt-2 pb-2'} key={course.id}>{ course.name } { course.finished ? (
                                    <span style={{ color: 'red' }}>(course finished)</span>
                                ) : '' }</div>
                            }) }

                            { !filteredCourses.length && (
                                'No available courses'
                            ) }
                        </div>
                        <div className={'col-7'}><a href={''} onClick={async e => {
                            e.preventDefault();
                            setModalVisible(true);
                        }}>(Change)</a></div>
                    </div>

                    <Modal isOpen={modalVisible}
                           className={'large-modal'}
                           toggle={() => setModalVisible(!modalVisible)}>
                        <ModalHeader toggle={() => setModalVisible(false)}>Courses settings</ModalHeader>
                        <ModalBody>
                            <div className={'mb-3'} />
                            <CourseCheckbox
                                title={'Free test'}
                                callback={e => {
                                    setLocalCourses([]);

                                    addSubscription({
                                        variables: {
                                            userId: userData?.id,
                                            removeAll: true
                                        }
                                    });
                                }}
                                checked={!localCourses.length} />

                            <CourseCheckbox
                                title={'All'}
                                callback={e => {
                                    setLocalCourses(localCourses.includes('all') ? [] : ['all']);

                                    addSubscription({
                                        variables: {
                                            userId: userData?.id,
                                            all: true
                                        }
                                    });
                                }}
                                checked={localCourses.includes('all')} />

                            { userData.courses.map(course => {
                                return <CourseCheckbox
                                    key={course.id}
                                    title={course.name}
                                    disabled={localCourses.includes('all')}
                                    callback={e => {
                                        setLocalCourses([...localCourses, course.id]);

                                        addSubscription({
                                            variables: {
                                                userId: userData?.id,
                                                courseId: course.id
                                            }
                                        });
                                    }}
                                    checked={localCourses.includes('all') || localCourses.includes(course.id)} />
                            }) }
                        </ModalBody>
                    </Modal>
                </>
            ) }
        </div>
    </div>
}
